/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import React from "react";
import {
  showPageNumberUIInModernViewer,
  showZoomControl,
  showZoomUI,
  showPageNavigationInModernViewer,
  showTwoColumnButton,
  showRotateViewButton,
  showPageViewSwitcherVisibility
} from "selectors/hudSelectors";
import { NavigationBar } from "components/navigationBar/NavigationBar";
import localizeComponent from "dc-preview-utils/src/Utils/LocalizationUtil";
import loadTranslation from "utils/TranslationUtil";
import { init, cleanup } from "services/NavigationBarService";
import { withTheme } from "context/themeContext";
import { getIsPreviewMounted } from "selectors/appSelectors";

const mapStoreToProps = stores => ({
  init,
  cleanup,
  showZoomUI: showZoomUI(stores),
  showZoomControl: showZoomControl(stores),
  showPageNavigation: showPageNavigationInModernViewer(stores),
  showPageNumber: showPageNumberUIInModernViewer(stores),
  showTwoColumnButton: showTwoColumnButton(stores),
  showRotateViewButton: showRotateViewButton(stores),
  showPageViewSwitcher: showPageViewSwitcherVisibility(stores),
  setRotateViewButtonVisibility: stores.hudStore.setRotateViewButtonVisibility,
  setHudDisable: stores.hudStore.setHudDisable,
  setPageNavigationVisibility: stores.hudStore.setPageNavigationVisibility,
  setPageNumberVisibility: stores.hudStore.setPageNumberVisibility,
  setZoomUIVisibility: stores.hudStore.setZoomUIVisibility,
  setZoomControlsVisibility: stores.hudStore.setZoomControlsVisibility,
  setFitWidthModeVisibility: stores.hudStore.setFitWidthModeVisibility,
  setFitPageModeVisibility: stores.hudStore.setFitPageModeVisibility,
  setFixedWidthVisibility: stores.hudStore.setFixedWidthVisibility,
  setTwoColumnButtonVisibility: stores.hudStore.setTwoColumnButtonVisibility,
  setPrintVisibility: stores.hudStore.setPrintVisibility,
  enableThemeSwitcher: stores.appStore.enableThemeSwitcher
});

const NavigationBarContainer = localizeComponent(inject(mapStoreToProps)(withTheme(NavigationBar)), loadTranslation);

const mapStoreToPropsWrapper = stores => ({ isPreviewMounted: getIsPreviewMounted(stores) });

const NavigationBarWrapper = ({ isPreviewMounted, ...props }) =>
  isPreviewMounted ? <NavigationBarContainer {...props} /> : null;

const NavigationBarWrapperContainer = inject(mapStoreToPropsWrapper)(NavigationBarWrapper);

export { NavigationBarWrapperContainer as NavigationBarContainer };
